module.exports = __webpack_public_path__ + "media/square.967ea4c0.ogg";